/* eslint-disable jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { getFormattedDistance } from '@/utils/Common/Utils';

const AddressResult = ({ index, store, markers, googleMap }) => {
  const getType = () => {
    const types = Object.keys(store.features).map(key => (
      <p key={key} className='dln-addressResult__productCategory'>
        {store.features[key]}
      </p>
    ));
    return types;
  };

  const handleMarker = () => {
    markers.map(marker => marker.infoWindow.close());
    markers[index].infoWindow.open(googleMap, markers[index]);
  };
  return (
    <button type='button' className='dln-addressResult' onClick={handleMarker}>
      <span className='dln-addressResult__head'>
        <span className='dln-addressResult__pinIndex'>{index + 1}</span>
        <strong className='dln-addressResult__company'>
          {store.displayName}
        </strong>
        <span className='dln-addressResult__distance'>
          {getFormattedDistance(store.formattedDistance)}
        </span>
        <i className='dln-icn dln-icn--iconfont'>d</i>
      </span>
      <span className='dln-addressResult__info'>
        <span className='dln-addressResult__data'>
          {store.address.line1}
          {store.address.line2 && <>,&nbsp;{store.address.line2}</>}
        </span>
        <span className='dln-addressResult__data'>{store.address.town}</span>
        <span className='dln-addressResult__data'>
          {store.address.region && store.address.region.name && (
            <>{store.address.region.name},&nbsp;</>
          )}
          {!store.address.region && store.address.district && (
            <>{store.address.district},&nbsp;</>
          )}
          <span>{store.address.postalCode}</span>
        </span>
        <span className='dln-addressResult__data'>
          {store.address.country && <span>{store.address.country.name}</span>}
        </span>
        {getType()}
      </span>
    </button>
  );
};

AddressResult.propTypes = {
  store: PropTypes.shape().isRequired,
  index: PropTypes.number.isRequired,
  markers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  googleMap: PropTypes.shape(),
};

AddressResult.defaultProps = {
  googleMap: null,
};

export default AddressResult;
